import React from 'react';
import { useTranslation } from 'react-i18next';
import { LiliButton, LiliButtonType } from '@lili/lili-frontend-common';
import { CloseButton, CloseButtonColor } from '../../DesignSystem/LiliCloseButton/CloseButton';
import { useStore } from '../../store';
import { LiliTextInput } from '../../DesignSystem/LiliTextInput/LiliTextInput';
import { ISummaryData } from '../../types';

export interface ChangeEmailProps {
  onClose: () => void;
  onEmailChanged: (input: string) => void;
  newEmail: string;
  errorMessage: string | undefined;
  isLoading: boolean;
  onSubmit: () => void;
  onBlur: () => void;
  isValid: boolean;
}

export const ChangeEmailForm = ({
  onClose,
  onEmailChanged,
  newEmail,
  errorMessage,
  isLoading,
  onSubmit,
  onBlur,
  isValid,
}: ChangeEmailProps) => {
  const { t } = useTranslation();
  const {
    customer: { email },
  }: ISummaryData = useStore((state) => state.summary);
  return (
    <div className='flex flex-col bg-bw01 rounded-[12px]  animate-fadeIn pb-[24px] w-[568px] '>
      <div className='w-full flex flex-row justify-between px-[24px]  h-[64px] items-center'>
        <p className='text-bw08 text-[16px] font-metricMedium  w-full'>{t('CHANGE_EMAIL.TITLE')}</p>
        <CloseButton id='close-button' color={CloseButtonColor.Black} onClick={onClose} />
      </div>
      <div className='flex justify-start border-b  border-bw03' />
      <div className='px-[24px] w-full pt-6 pb-3'>
        <p className='text-bw08 text-[16px] font-metricR mt-[8px]'>{t('CHANGE_EMAIL.CURRENT_EMAIL')}</p>
        <p id='currentEmail' className='text-bw08 text-[16px] font-metricR '>{email}</p>
        <p className='text-bw08 text-[16px] font-metricR  mt-[20px] mb-[4px]'>{t('CHANGE_EMAIL.NEW_EMAIL_TITLE')}</p>
        <div className='h-[80px]'>
          <LiliTextInput
            id='email-input'
            title={t('CHANGE_EMAIL.NEW_EMAIL_TITLE')}
            value={newEmail}
            onChange={onEmailChanged}
            errorMessage={errorMessage}
            onBlur={onBlur}
            isOnclearButtonVisible={false}
          />
        </div>

        <div className='h-[36px] mt-[37px] flex  justify-end gap-3'>
          <div className='w-[110px]'>
            <LiliButton
              id='cancle-button'
              title={t('CHANGE_EMAIL.CANCEL')}
              onClick={onClose}
              isLoading={false}
              disabled={false}
              type={LiliButtonType.SECONDARY}
              className='h-[44px] w-[110px]'
            />
          </div>

          <LiliButton
            id='submit-button'
            title={t('CHANGE_EMAIL.SUBMIT_BUTTON')}
            onClick={onSubmit}
            isLoading={isLoading}
            disabled={errorMessage !== undefined || !isValid}
            className='h-[44px] w-[142px]'
          />
        </div>
      </div>
    </div>
  );
};
